<template>
  <div v-if="ready">
    <SolicitacaoListagemHeader
      :rota-historico="rotaHistorico"
      :rota-novo="rotaNovo"
      :permite-novo="permiteNovaSolicitacao"
    />
    <ComponenteSolicitacaoListagem
      :funcionalidade="funcionalidade"
      :lista-externa="listaExterna"
      :chave-externa="chaveExterna"
      :lista-interna="listaInterna"
      :rota-historico="rotaHistorico"
      :rota-novo="rotaNovo"
      :permite-novo="permiteNovaSolicitacao"
      :quantidadeItens="funcionalidade.parametros.quantidadeItensLista"
    >
      <template v-slot:externo="{card}">
        <slot
          :card="card"
        />
      </template>

      <template v-slot:interno="{card}">
        <div
          @click="detalhe(card)"
        >
          <ListaStatusCard
            :card="card"
            :showWidgetActions="showWidgetActions"
          />
        </div>
      </template>
    </ComponenteSolicitacaoListagem>
  </div>
</template>

<script>
import ComponenteSolicitacaoListagem from '@/components/TemplateSolicitacao/componentes/ComponenteSolicitacaoListagem'
import ListaStatusCard from '@/components/TemplateSolicitacao/componentes/ListaStatusCard'
import SolicitacaoListagemHeader from '@/components/TemplateSolicitacao/componentes/SolicitacaoListagemHeader'
import { mapGetters, mapState } from 'vuex'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'

export default {
  name: 'SolicitacaoListagem',
  components: { SolicitacaoListagemHeader, ListaStatusCard, ComponenteSolicitacaoListagem },
  props: {
    funcionalidade: {
      type: Object,
      default: () => ({})
    },
    listaExterna: {
      type: Array,
      default: () => []
    },
    chaveExterna: {
      type: String,
      default: ''
    },
    rotaNovo: {
      type: String,
      defalut: ''
    },
    rotaDetalhe: {
      type: String,
      defalut: ''
    },
    rotaHistorico: {
      type: String,
      defalut: ''
    },
    permiteNovaSolicitacao: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      listaInterna: [],
      ready: false
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiSolicitacao']),
    ...mapGetters('Login', ['isLogin']),
    ...mapGetters('SetupApp', ['canalAtendimentoOrigem']),
    showWidgetActions () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return false
      }
    }
  },
  methods: {
    async init () {
      if (!this.isLogin && this.rotaNovo && this.permiteNovaSolicitacao && !this.showWidgetActions) {
        return this.gotoNovo()
      }
      await this.getList()
    },
    detalhe (card) {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return this.$router.push({
            path: this.rotaDetalhe,
            query: {
              idOcorrencia: card['id_ocorrencia']
            }
          })
      }
    },
    async getList () {
      const data = new Date()
      data.setMonth(data.getMonth() - 1)
      const response = await this.apiSolicitacao.solicitacao({
        headers: {
          id_funcionalidade: this.funcionalidade.idFuncionalidade,
          data_inicial: data.getTime(),
          data_final: new Date().getTime()
        },
        loading: true,
        handlerErrorIgnore: true
      })
      this.listaInterna = response.data.contratos
      this.ready = true
    },
    gotoNovo () {
      this.$router.push({
        path: this.rotaNovo
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style scoped>
</style>
